import { NgModule } from '@angular/core';
import { Idle } from './idle';
import { IdleExpiry } from './idleexpiry';
import { SimpleExpiry } from './simpleexpiry';
export var NgIdleModule = (function () {
    function NgIdleModule() {
    }
    NgIdleModule.forRoot = function () {
        return {
            ngModule: NgIdleModule,
            providers: [SimpleExpiry, { provide: IdleExpiry, useExisting: SimpleExpiry }, Idle]
        };
    };
    NgIdleModule.decorators = [
        { type: NgModule },
    ];
    /** @nocollapse */
    NgIdleModule.ctorParameters = [];
    return NgIdleModule;
}());
//# sourceMappingURL=module.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/@ng-idle/core/src/module.js
// module id = ../../../../@ng-idle/core/src/module.js
// module chunks = 3